import api from "./axios";

export type DocumentType = "offer" | "invoice" | "avr" | "waybill" | "warranty" | "estimate" | "contract" | "act" | "avr_pc" | "intake" | "intake_label";

export interface IntakeItem { type?: string; model?: string; serial?: string; accessories?: string; condition?: string; complaint?: string }
export interface IntakeData { items: IntakeItem[]; workType?: string; estimate?: number | null; readyDate?: string | null; note?: string }

export const VIDEO_DOC_TYPES: DocumentType[] = ["estimate", "contract", "act"];
/** Документы без Excel-версии */
export const NO_EXCEL_TYPES: DocumentType[] = ["estimate", "contract", "act", "avr_pc", "intake", "intake_label"];

export const DOC_LABELS: Record<DocumentType, string> = {
  offer: "КП",
  invoice: "Счёт",
  avr: "АВР",
  waybill: "Накладная",
  warranty: "Гарантийный талон",
  estimate: "Смета (видеонаблюдение)",
  contract: "Договор (видеонаблюдение)",
  act: "Акт приёма-передачи (видеонаблюдение)",
  avr_pc: "АВР физлицо (обслуживание ПК)",
  intake: "Акт приёма техники",
  intake_label: "Этикетка приёма",
};

export const DocumentsAPI = {
  getByDeal: async (dealId: number) => {
    const res = await api.get(`/documents/by-deal/${dealId}`);
    return res.data;
  },

  generate: async (dealId: number, type: DocumentType, opts?: { docNumber?: string; contract?: string; docDate?: string; terms?: Record<string, number>; intake?: IntakeData }) => {
    const res = await api.post(`/documents/generate/${dealId}`, { type, ...opts });
    return res.data;
  },

  downloadPdf: async (documentId: number) => {
    const win = window.open("", "_blank");
    try {
      const res = await api.get(`/documents/secure-download/${documentId}`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      if (win) win.location.href = url;
      else window.location.href = url;
      setTimeout(() => URL.revokeObjectURL(url), 60_000);
    } catch {
      win?.close();
      alert("Не удалось открыть документ");
    }
  },

  downloadExcel: (documentId: number) => {
    window.open(`/api/documents/download-excel/${documentId}`, "_blank");
  },

  delete: async (documentId: number) => {
    await api.delete(`/documents/${documentId}`);
  },
};
